import utils from '../../../Shared/utils.jsx';

/**
 * Resolve a schema document path to an Apps/UIWhole document URL.
 * Covers Schema.Type=URL Definition values and Reference `$ref` values.
 * Accepts schema/public/... paths (with optional leading slash).
 */
export function resolveSchemaDocumentUrl(schemakey, cmodel, value) {
    const isDefinitionUrl = schemakey === 'Definition' && cmodel?.Type === 'URL';
    const isRef = schemakey === '$ref';
    if ((!isDefinitionUrl && !isRef) || typeof value !== 'string')
        return null;

    const trimmed = value.trim();
    if (!trimmed)
        return null;

    const withoutLeadingSlash = trimmed.replace(/^\/+/, '');
    const lower = withoutLeadingSlash.toLowerCase();
    if (lower.startsWith('apps/uiwhole/'))
        return withoutLeadingSlash;
    if (lower.startsWith('apps/raw/schema/'))
        return 'Apps/UIWhole/' + withoutLeadingSlash.slice('Apps/Raw/Schema/'.length);
    if (!lower.startsWith('schema/'))
        return null;

    return 'Apps/UIWhole/' + withoutLeadingSlash;
}

/**
 * Open a schema document in a new portal tab (EmbeddedEditor), not in-place in ControlDesigner.
 */
export function openSchemaDocumentInTab(event, schemaUrl, value) {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (event)
        event.cancelBubble = true;

    if (!schemaUrl)
        return;

    const tabTitle = typeof value === 'string' && value.trim()
        ? value.trim().split(/[/?#]/).pop()
        : schemaUrl.split('/').pop();

    utils.openForLocalEdit({
        GetDocumentBy: 'URL',
        URL: schemaUrl,
        Title: tabTitle,
    });
}
